"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("../../../../components/Input"));

var _Tooltip = _interopRequireDefault(require("../../../../components/Tooltip"));

var View = function View(_ref) {
  var name = _ref.name,
      domain = _ref.domain,
      disabled = _ref.disabled,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["name", "domain", "disabled"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex items-center bg-secondary font-bold mr-2"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
    size: "md",
    name: name,
    spellCheck: "false",
    autoComplete: "off",
    disabled: disabled,
    className: "flex-1 font-bold pr-0 border-none bg-secondary"
  })), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: domain
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mx-4 text-primary truncate",
    style: {
      maxWidth: 150
    }
  }, "@".concat(domain))));
};

View.displayTitle = 'InputWithDomain';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=InputWithDomain.js.map